import Vue from 'vue'
import App from './App.vue'


import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck, faChevronRight, faPlus, faArrowAltCircleUp, faCalendarAlt, faClock, faEnvelope, faKey, faFolder, faEllipsisH, faCalendarWeek, faCalendarDay, faAngleDown, faAngleLeft, faSave } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import VCalendar from 'v-calendar';

library.add(faCheck, faChevronRight, faPlus, faArrowAltCircleUp, faCalendarAlt, faClock, faEnvelope, faKey, faFolder, faEllipsisH, faCalendarWeek, faCalendarDay, faAngleDown, faAngleLeft, faSave )

Vue.component('font-awesome-icon', FontAwesomeIcon)


// Use v-calendar & v-date-picker components
Vue.use(VCalendar);

Vue.config.productionTip = false


new Vue({
  render: h => h(App),
}).$mount('#app')
